import { Button, Checkbox, Divider, Flex } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingWrapper, Scroll, Title, Wrapper } from './HideUserSubscriptions.styles';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { useUserSubscriptionsVisibility } from '@/hooks';

interface Props {
  studentId: string;
}

export const HideUserSubscriptions: React.FC<Props> = ({ studentId }) => {
  const { t } = useTranslation();
  const { subscriptions, isLoading, localSelected, onToggle, canSave, isSaving, saveVisibility } =
    useUserSubscriptionsVisibility(studentId);

  const onSave = async () => {
    await saveVisibility();
  };

  return (
    <Wrapper gap={14}>
      <Flex justify="space-between" align="center">
        <Title>{t('COURSES')}</Title>
        <Button
          type="primary"
          size="small"
          onClick={onSave}
          disabled={!canSave}
          loading={isLoading || isSaving}>
          {t('SAVE_CHANGES')}
        </Button>
      </Flex>
      <Divider style={{ margin: '0' }} />
      <Scroll>
        {isLoading ? (
          <LoadingWrapper>
            <LoadingCircleSpinner />
          </LoadingWrapper>
        ) : (
          <Flex vertical gap={8}>
            {(subscriptions || []).map(sub => (
              <Flex key={sub._id} align="center" gap={8}>
                <Checkbox
                  checked={localSelected[sub._id] ?? !sub.isHidden}
                  onChange={() => onToggle(sub._id)}
                />
                <span>
                  {sub.course?.emoji ? `${sub.course.emoji} ` : ''}
                  {sub.course?.name}
                </span>
              </Flex>
            ))}
          </Flex>
        )}
      </Scroll>
    </Wrapper>
  );
};
